import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  computed,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { FooterComponent } from '@chefami-monorepo/ui/footer';
import { CenteredHeaderComponent } from '@chefami-monorepo/ui/centered-header';
import { AuthService } from '@chefami-monorepo/data-access';
import { UserData } from '@chefami-monorepo/types';

@Component({
  selector: 'app-root',
  imports: [RouterModule, FooterComponent, CenteredHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly auth = inject(AuthService);

  readonly userData = this.auth.userData;
  readonly siteInfo = this.auth.siteInfo;
  readonly isLoggedIn = this.auth.isLoggedIn;

  readonly headerFooterOptions = computed<UserData>(() => ({
    isLoggedIn: this.isLoggedIn() ?? false,
    userInfo: this.userData()?.userInfo ?? undefined,
    siteInfo: this.siteInfo(),
  }));
}
